import axiosClient from "../axios/axiosClient";

export function getSpecialisations() {
  return axiosClient.get("/specialisations");
}

export function getSpecialisation(specialisationId) {
  return axiosClient.get(`/specialisations/${specialisationId}`);
}

export function createSpecialisation(data) {
  return axiosClient.post("/specialisations", data);
}

export const updateSpecialisation = (specialisationId, data) => {
  return axiosClient.put(`/specialisations/${specialisationId}`, data);
};

export function deleteSpecialisation(specialisationId) {
  return axiosClient.delete(`/specialisations/${specialisationId}`);
}
